module.exports = __webpack_public_path__ + "img/arrowLeft.44794b26.svg";